import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { customerTypeList, categoryList, paymentList, currencyList, channelTypeList, typeList, platformList, dailyCostList, advertiserAuditList, sourceList, businessTypeList, projectTypeList, caseAuthTypeList, interactiveMaterialTypeList, noninteractiveSecondaryLevelTagList, noninteractiveThirdLevelTagList, contentRatingList, reportPointList, creativeGenreList, bizScenario } from '@/common/demand';
import { exchange } from '@/views/demand/utils';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';
import { creationTypeList } from '@/views/demand/utils/creation';
import TableList from '@/components/TableList/index.vue';
import demandMixin from '../create/demand-mixin';
import Invoice from './invoice';
import MForm from 'm-form';
import { interactiveChannelList } from '@com/utils/channel';
import { allNonInteractiveChannelList } from '@/views/demand/utils/creation';

export default {
  mixins: [demandMixin],

  components: {
    TableList: TableList,
    MForm: MForm,
    Invoice: Invoice
  },

  props: {
    demand: {
      type: Object,
      required: true
    },

    creationList: {
      type: Array,
      required: true
    },

    products: {
      type: Array,
      required: true
    }
  },

  data: function data() {
    return {
      formConfig: {
        labelWidth: '100px',
        labelPosition: 'right'
      }
    };
  },


  computed: {
    tableColumnConfig: function tableColumnConfig() {
      return [{
        label: '创意类型',
        prop: 'type'
      }, {
        label: '投放渠道',
        prop: 'channel'
      }, {
        label: '投放语言',
        prop: 'languages'
      }, {
        visible: !this.isInteractiveCreation,
        label: '创意尺寸',
        prop: 'sizes'
      }];
    },
    demandFormItemList: function demandFormItemList() {
      var h = this.$createElement;

      return {
        name: {
          label: '需求名称：',
          prop: 'name',
          type: 'plain-text'
        },
        instruction: {
          label: '需求说明：',
          prop: 'instruction',
          component: {
            functional: true,
            render: function render(h, context) {
              if (context.props.formValue.material_source === 3) {
                var _list = context.props.formValue.instruction.split('\n');
                return _list.map(function (item) {
                  var listItem = item.split('：');
                  return h(
                    'div',
                    null,
                    [h(
                      'strong',
                      null,
                      [listItem[0], '\uFF1A']
                    ), h(
                      'a',
                      {
                        attrs: { target: '_blank', href: listItem[1] }
                      },
                      [listItem[1]]
                    )]
                  );
                });
              }

              var list = context.props.formValue.instruction.split('\n');
              return list.map(function (item) {
                return h(
                  'div',
                  { style: 'word-break:break-all;' },
                  [item]
                );
              });
            }
          }
        },
        adv_name: {
          label: '广告主名称：',
          prop: 'adv_name',
          type: 'plain-text'
        },
        invoice_id: {
          visible: this.isDesign,
          label: 'Related invoice：',
          prop: 'invoice_id',
          slot: 'invoice_id'
        },
        reference_url: {
          label: '参考附件：',
          prop: 'reference_url',
          type: 'link',
          params: {
            target: '_blank'
          }
        },
        category: {
          label: '需求归属：',
          prop: 'category',
          type: 'plain-text'
        },
        expect_time: {
          label: '期望交付日期：',
          prop: 'expect_time',
          type: 'plain-text'
        },
        platform: {
          label: '投放平台：',
          prop: 'platform',
          type: 'plain-text'
        }
      };
    },
    demandFormItemList2: function demandFormItemList2() {
      var list = {
        key_account: {
          visible: this.isMintegral || this.isBigMedia,
          label: '是否KA：',
          prop: 'key_account',
          type: 'plain-text'
        },
        is_pay: {
          label: '付费情况：',
          prop: 'is_pay',
          type: 'plain-text'
        },
        currency: {
          visible: this.isDesign && this.isPay,
          label: '币种：',
          prop: 'currency',
          type: 'plain-text'
        },
        exchange_rate: {
          visible: this.isDesign && this.isPay,
          label: '美金兑人民币汇率：',
          prop: 'exchange_rate',
          type: 'plain-text'
        },
        revenue_usd: {
          visible: this.isDesign && this.isPay,
          label: 'Revenue USD：',
          prop: 'revenue_usd',
          type: 'plain-text'
        },
        revenue_cny: {
          visible: this.isDesign && this.isPay,
          label: 'Revenue CNY：',
          prop: 'revenue_cny',
          type: 'plain-text'
        },
        cost_usd: {
          visible: this.isDesign && this.isPay,
          label: 'Cost USD：',
          prop: 'cost_usd',
          type: 'plain-text'
        },
        cost_cny: {
          visible: this.isDesign && this.isPay,
          label: 'Cost CNY：',
          prop: 'cost_cny',
          type: 'plain-text'
        },
        is_prepaid: {
          visible: this.isDesign && this.isPay,
          label: '是否预付：',
          prop: 'is_prepaid',
          type: 'plain-text'
        },
        prepaid_percent: {
          visible: this.isDesign && this.isPay && this.isPrepaid,
          label: '预付比例：',
          prop: 'prepaid_percent',
          type: 'plain-text'
        },
        crm_contract_no: {
          visible: this.isDesign && this.isPay,
          label: 'CRM 合同编号：',
          prop: 'crm_contract_no',
          type: 'plain-text'
        }
      };

      return list;
    },
    demandFormItemList3: function demandFormItemList3() {
      return {
        channel_type: {
          label: '投放渠道类型：',
          prop: 'channel_type',
          type: 'plain-text'
        },
        type: {
          label: '需求类型：',
          prop: 'type',
          type: 'plain-text'
        },
        biz_scenario: {
          label: '业务场景：',
          prop: 'biz_scenario',
          type: 'plain-text'
        }
      };
    },
    demandFormItemList4: function demandFormItemList4() {
      var isDesignAndInteractive = this.isDesign && this.isInteractiveCreation;
      var isDesignAndNonInteractive = this.isDesign && this.isNonInteractiveCreation;

      var list = {
        is_pt_custom: {
          visible: isDesignAndInteractive,
          label: 'Playturbo 定制：',
          prop: 'is_pt_custom',
          type: 'plain-text'
        },
        is_make_dco: {
          visible: isDesignAndInteractive,
          label: '制作 DCO：',
          prop: 'is_make_dco',
          type: 'plain-text'
        },
        ia_material_type: {
          visible: isDesignAndInteractive,
          label: '需求素材类型：',
          prop: 'ia_material_type',
          type: 'plain-text'
        },
        nia_tag2_id: {
          visible: isDesignAndNonInteractive,
          label: '二级标签：',
          prop: 'nia_tag2_id',
          type: 'plain-text'
        },
        nia_tag3_id: {
          visible: isDesignAndNonInteractive,
          label: '三级标签：',
          prop: 'nia_tag3_id',
          type: 'plain-text'
        },
        case_auth_type: {
          visible: this.isDesign,
          label: '案例宣传授权：',
          prop: 'case_auth_type',
          type: 'plain-text'
        },
        case_remark: {
          visible: this.isDesign && this.demand.case_auth_type === 3,
          label: '案例宣传备注：',
          prop: 'case_remark',
          type: 'plain-text'
        },

        is_advertiser_review: {
          visible: this.isInteractiveCreation,
          label: '广告主是否审核：',
          prop: 'is_advertiser_review',
          type: 'plain-text'
        },
        content_rating: {
          visible: this.isInteractiveCreation && !!this.demand.channel_setting && this.demand.channel_ids.indexOf(9) !== -1,
          label: '适龄提示：',
          prop: 'content_rating',
          type: 'plain-text'
        },
        ir_report_point: {
          visible: this.isInteractiveCreation && !!this.demand.channel_setting && this.demand.channel_ids.indexOf(10) !== -1,
          label: '是否接入IR埋点：',
          prop: 'ir_report_point',
          type: 'plain-text'
        },
        ir_creative_genre: {
          visible: this.isInteractiveCreation && !!this.demand.channel_setting && this.demand.channel_ids.indexOf(10) !== -1 && this.demand.ir_report_point,
          label: '创意流派：',
          prop: 'ir_creative_genre',
          type: 'plain-text'
        },
        similar_demands: {
          label: '参考需求：',
          prop: 'similar_demands',
          type: 'plain-text'
        },
        material_source: {
          label: '素材来源：',
          prop: 'material_source',
          type: 'plain-text'
        },
        account_manager_name: {
          label: 'AM：',
          prop: 'account_manager_name',
          type: 'plain-text'
        },
        business_type: {
          visible: this.isNoninteractiveAndBigMedia,
          label: '大媒体业务类型：',
          prop: 'business_type',
          type: 'plain-text'
        },
        is_new_order: {
          visible: this.isNoninteractiveAndBigMedia,
          label: '是否新单：',
          prop: 'is_new_order',
          type: 'plain-text'
        },
        project_type: {
          visible: this.isNonInteractiveCreation,
          label: '项目类型：',
          prop: 'project_type',
          type: 'plain-text'
        },
        big_media_is_use_template: {
          visible: this.isNoninteractiveAndBigMedia,
          label: '是否使用模板：',
          prop: 'big_media_is_use_template',
          type: 'plain-text'
        },
        big_media_tpl_id: {
          visible: this.isNoninteractiveAndBigMedia && this.demand.big_media_is_use_template === 1,
          label: '大媒体模板 id：',
          prop: 'big_media_tpl_id',
          type: 'plain-text'
        },
        big_media_creative_type: {
          visible: this.isNoninteractiveAndBigMedia && this.demand.big_media_is_use_template === 2,
          label: '大媒体创意类型：',
          prop: this.demand.big_media_creative_type_other ? 'big_media_creative_type_other' : 'big_media_creative_type',
          type: 'plain-text'
        }
      };
      return list;
    },
    productFormItemList: function productFormItemList() {
      return {
        app_name: {
          label: '产品名称：',
          prop: 'app_name',
          type: 'plain-text'
        },
        app_url: {
          label: '产品链接：',
          prop: 'app_url',
          type: 'link',
          params: {
            target: '_blank'
          }
        },
        package_name: {
          label: '包名/Appid：',
          prop: 'package_name',
          type: 'plain-text'
        },
        offer_uuid: {
          label: 'UUID：',
          prop: 'offer_uuid',
          type: 'plain-text'
        },
        mtg_daily_cost: {
          label: 'Mtg渠道日均消耗：',
          prop: 'mtg_daily_cost',
          type: 'plain-text'
        }
      };
    },
    innerDemand: function innerDemand() {
      var _this = this;

      var map = {
        key_account: customerTypeList,
        category: categoryList,
        is_pay: paymentList,
        currency: currencyList,
        channel_type: channelTypeList,
        type: typeList,
        platform: platformList,
        is_advertiser_review: advertiserAuditList,
        business_type: businessTypeList,
        case_auth_type: caseAuthTypeList,
        ia_material_type: interactiveMaterialTypeList,
        nia_tag2_id: noninteractiveSecondaryLevelTagList,
        nia_tag3_id: noninteractiveThirdLevelTagList,
        content_rating: contentRatingList,
        ir_report_point: reportPointList,
        ir_creative_genre: creativeGenreList,
        biz_scenario: bizScenario
      };
      var newDemand = exchange(this.demand, map);

      var utils = {
        prepaid_percent: function prepaid_percent(value) {
          return value + '%';
        },
        similar_demands: function similar_demands(value) {
          return (value || []).map(function (e) {
            return '（' + e.id + '）' + e.name;
          }).join();
        },
        material_source: function material_source(value) {
          return (sourceList.find(function (e) {
            return e.value === value;
          }) || {}).label;
        },
        is_new_order: function is_new_order(value) {
          return value === 1 ? '是' : '否';
        },
        project_type: function project_type(value) {
          var type = useValueExchangeLabel(value, projectTypeList);
          if (value === 99) {
            type = '' + _this.demand.project_other;
          }
          return type;
        },
        big_media_is_use_template: function big_media_is_use_template(value) {
          return value === 1 ? '是' : '否';
        },
        is_prepaid: function is_prepaid(value) {
          return value === 1 ? '是' : '否';
        },
        is_pt_custom: function is_pt_custom(value) {
          return value === 1 ? '是' : '否';
        },
        is_make_dco: function is_make_dco(value) {
          return value === 1 ? '是' : '否';
        }
      };

      _.each(this.demand, function (value, key) {
        if (utils[key]) {
          newDemand[key] = utils[key](value);
        }
      });

      return newDemand;
    },
    innerCreationList: function innerCreationList() {
      var map = {
        type: creationTypeList,
        channel: this.demand.type === 1 ? interactiveChannelList : allNonInteractiveChannelList()
      };
      return this.creationList.map(function (creation) {
        return exchange(creation, map);
      });
    },
    innerProducts: function innerProducts() {
      var _this2 = this;

      var map = {
        platform: platformList,
        mtg_daily_cost: dailyCostList
      };

      return this.products.map(function (product) {
        var newProduct = exchange(product, map);
        return _extends({}, newProduct, { adv_name: _this2.demand.adv_name });
      });
    }
  },

  methods: {}
};